import { palette } from '@livable/saas-react-components';
const MuiAvatar = {
  styleOverrides: {
    root: {
      width: '32px',
      height: '32px',
      borderRadius: '2px',
      background: palette.brandGradients.fade,
      color: palette.shades[700],
      transition: "color ".concat(palette.transitions.short),
      '& .MuiTypography-root': {
        color: palette.shades[700],
        transition: "color ".concat(palette.transitions.short)
      },
      '&:hover': {
        color: palette.shades[800],
        '& .MuiTypography-root': {
          color: palette.shades[800]
        }
      }
    }
  }
};
export default MuiAvatar;